import { ReactElement, ReactNode } from 'react'

import * as Styled from './styles'

interface ExpertReportHeaderActionsProps {
  children: ReactNode
}

export const ExpertReportHeaderActions = ({ children }: ExpertReportHeaderActionsProps): ReactElement => (
  <Styled.HeaderActionsWrapper>{children}</Styled.HeaderActionsWrapper>
)
